module.exports = __webpack_public_path__ + "static/media/key_white.9856b820.svg";